define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var config = require('config');
    var user = require('user');
    var urlUtil = require('util/url.util');
    var { dispatcher, getDeviceId } = require('bundle');
    var languageUtil = require('util/language.util');
    var deviceUtil = require('util/device.util');
    var AuthManager = require('managers/spanish-regulations/auth.manager');

    /**
     * @class
     * @name AuthManager
     * @augments AuthManager
     */
    module.exports = AuthManager.extend({
        /**
         * Register user on IMS.
         * @private
         * @param  {Object} options
         * @return {Deferred}
         */
        register: function(options) {
            var def = $.Deferred();
            var lang = languageUtil.convertToIMS(user.get('lang'));
            var formData = user.get('formData');
            var registrationInfo = user.get('registrationInfo');
            var signupUserAgent = window.navigator.userAgent; /* Sportium changes */
            var deviceType = urlUtil.getLocationParameterByName('deviceType');
            var signUpInfo = {
                signupDeviceType: deviceType ?? deviceUtil.alias,
                signupOsName: deviceUtil.os,
                signupOsVersion: deviceUtil.osVersion,
                signupDeliveryPlatform: deviceUtil.deliveryPlatform.slice(0, 50),
                signupDeviceBrowser: deviceUtil.browserName,
                signupUserAgent: signupUserAgent /* Sportium changes */
            };
            var data = _.extend({}, formData, signUpInfo);

            if (registrationInfo?.playerHash) {
                data = _.extend({}, data, {
                    playerHash: registrationInfo?.playerHash
                });
            }

            if (!lang) {
                return $.Deferred().reject({
                    ID: -1,
                    data: {
                        errorCode: -1,
                        errorMessage: 'User can\'t be logged in',
                        message: 'Failed to get two letter language'
                    }
                });
            }

            data.language = lang.toUpperCase();

            if (data.userName && config.get('isUsernameInUppercase')) {
                data.userName = data.userName.toUpperCase();
            }

            if (!data.userName && !data.loginName) {
                user.set('loginMode', 'email');
            }

            if (data.fitToPlay) {
                user.set('fitToPlay', Boolean(data.fitToPlay));

                // remove it from the request as it is handled during login
                delete data.fitToPlay;
            }

            if (registrationInfo?.externalToken) {
                user.set('loginMode', 'externalToken');
            }

            data.serial = getDeviceId();
            data.signupDeviceId = data.serial;

            var requests = [
                this._generateSubscriptionRequest(data),
                this._getDepositLimitRequest(data),
                this._getBetLimitRequest(data),
                this._getLossLimitRequest(data)
            ].filter(Boolean);

            var extendedOptions = _.extend({}, options, {
                externalToken: registrationInfo?.externalToken,
                personalId: data.personalId
            });

            //Batch goes here. We need only registration responses
            this._registrationRequest(data, requests, extendedOptions)
                .done(def.resolve)
                .fail(function(error) {
                    if (error.ID === 33006 && error.data.errorCode === 105) {
                        var dataWithoutTC = _.omit(data, 'tcVersion');

                        this._registrationRequest(dataWithoutTC, requests, extendedOptions)
                            .done(def.resolve)
                            .fail(function(e) {
                                options.error();
                                def.reject(e);
                            });
                    } else {
                        options.error();
                        def.reject(error);
                    }
                }.bind(this));

            dispatcher.dispatch('registration:submitted');

            return def.promise();
        }
    });
});
